import React from 'react';
import { Box, Stack } from '@mui/material';
import Editor from '../Editor';
import { updateKeypoints, updateSummary } from '../Network';
import {
  idKey,
  summaryKey,
  keypointsKey,
  isSummarizedKey
} from '../MeetingsKeysList';
import { EDITOR_DATA_TYPES } from './constants';

const MeetingEditor = ({ 
  meeting, 
  dataType, 
  onMeetingUpdate,
  onEditorSelectionChange
}) => {
  // Add logging to track MeetingEditor re-renders
  console.log('[MeetingEditor] Rendering:', {
    meetingId: meeting?.[idKey],
    dataType,
    isSummarized: meeting?.[isSummarizedKey],
    isEditable: meeting?.[isSummarizedKey] === 1,
    timestamp: Date.now()
  });

  if (!meeting) return null;

  const key = dataType === EDITOR_DATA_TYPES.SUMMARY ? summaryKey : keypointsKey;
  const content = meeting[key];
  
  const handleUpdate = async (value) => {
    if (value !== meeting[key]) {
      if (dataType === EDITOR_DATA_TYPES.SUMMARY) {
        await updateSummary(meeting[idKey], value);
        onMeetingUpdate?.(meeting[idKey], { [summaryKey]: value });
      } else {
        await updateKeypoints(meeting[idKey], value);
        onMeetingUpdate?.(meeting[idKey], { [keypointsKey]: value });
      }
    }
  };

  return (
    <Stack>
      <div key={`${meeting[idKey]}-${dataType}`}>
        {Editor(
          content, 
          handleUpdate, 
          true, 
          false, 
          meeting[isSummarizedKey] === 1, 
          false, 
          false,
          onEditorSelectionChange,
          meeting[idKey] // Pass meeting ID for HeaderAlertPlugin
        )}
      </div>
      <Box height="80px" />
    </Stack>
  );
};

MeetingEditor.displayName = 'MeetingEditor';

export default MeetingEditor; 